export class TableContextDecidedColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "metric",
            "baseName": "metric",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextDecidedColumn.attributeTypeMap;
    }
    constructor() {
    }
}
